export const NODE_TYPE = {
  MENU: "MENU",
  BUTTON: "BUTTON",
  API: "API",
};

export const NODE_TYPE_LABEL = {
  [NODE_TYPE.MENU]: "菜单",
  [NODE_TYPE.BUTTON]: "按钮",
  [NODE_TYPE.API]: "接口",
};

// The gateway currently stores API nodes as BUTTON rows with apiPath. Keep that
// storage format compatible while presenting the actual three concepts in the UI.
export function getNodeType(node) {
  if (!node) return "";
  if (node.menuType === "DIR" || node.menuType === "MENU") return NODE_TYPE.MENU;
  if (node.menuType === "API" || String(node.apiPath || "").trim()) return NODE_TYPE.API;
  return NODE_TYPE.BUTTON;
}

export function canUseParent(childType, parent) {
  if (!parent) return childType === NODE_TYPE.MENU;
  const parentType = getNodeType(parent);
  if (parentType === NODE_TYPE.MENU) return true;
  return parentType === NODE_TYPE.BUTTON && childType === NODE_TYPE.API;
}

export function canHaveChildren(node) {
  return getNodeType(node) !== NODE_TYPE.API;
}

export function toMenuPayload(editing) {
  const payload = { ...editing };
  delete payload.nodeType;
  delete payload.storageMenuType;
  delete payload.children;

  if (editing.nodeType === NODE_TYPE.MENU) {
    // Preserve legacy top-level DIR rows so existing navigation keeps working.
    // New and nested menus use MENU; both are shown as "菜单" in this page.
    payload.menuType = editing.storageMenuType === "DIR" && Number(editing.parentId) === 0
      ? "DIR"
      : "MENU";
    payload.apiPath = null;
    payload.apiMethod = null;
  } else {
    // ApiResourceCache reads BUTTON rows with a non-empty apiPath. A BUTTON row
    // without apiPath is a real UI button and may contain one or more API rows.
    payload.menuType = "BUTTON";
    payload.path = null;
    payload.component = null;
    payload.icon = null;
    if (editing.nodeType === NODE_TYPE.BUTTON) {
      payload.apiPath = null;
      payload.apiMethod = null;
    }
  }

  return payload;
}
